import React from "react";
import LeftNavHeader from "./LeftNavHeader";
import LeftNavFooter from "./LeftNavFooter";
import MenuList from "./MenuList";
import SidebarDrawer from "../../../../_default/SidebarDrawer";

export default function LeftNavBar({}) {
  return (
    <SidebarDrawer
      drawerStatesKey={"isLeftMenuOpen"}
      HeaderComponent={<LeftNavHeader />}
      FooterComponent={<LeftNavFooter />}
      ContentComponent={<MenuList />}
    />
  );
}
